import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const spinnerElement = document.querySelector("[data-controller~='spinner']")
    if (spinnerElement) {
      this.spinnerController = this.application.getControllerForElementAndIdentifier(spinnerElement, "spinner")
    }

    this.saving = false



    // gestione focus per Turbo
    document.addEventListener("turbo:before-fetch-request", this.saveFocus)
    document.addEventListener("turbo:frame-load", this.restoreFocus)
  }

  disconnect() {
    document.removeEventListener("turbo:before-fetch-request", this.saveFocus)
    document.removeEventListener("turbo:frame-load", this.restoreFocus)
  }

  // Metodo per il submit con debounce e updatePartial
  scheduleSubmit(select, delay) {
    console.log('delay' + delay)
    console.log('select' + select)
    if (this.saving) return
    clearTimeout(this.timeout)

    const updatePartial = select.dataset.autosaveUpdatePartial === "true"

    this.timeout = setTimeout(async () => {
      const form = select.form
      if (!form) return
      this.spinnerController?.show()
      this.saving = true

      if (updatePartial) {
        // submit normale del form → ricarica pagina o Turbo Frame
        form.requestSubmit()
      } else {
        // submit "silenzioso" → solo aggiornamento del campo
        try {
          const formData = new FormData()
          formData.append(select.name, select.value) // solo il campo selezionato

          await fetch(form.action, {
            method: "PATCH",
            body: formData,
            headers: {
              "Accept": "application/json", // Rails risponde solo con head :ok
              "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content
            },
            credentials: "same-origin"
          })
        } catch (e) {
          console.error("Errore autosave:", e)
        } finally {
          this.saving = false
          this.spinnerController?.hide()
        }
      }
    }, delay)
  }

  // Metodo legacy per select normali (action="change->autosave#change")
  change(event) {
    const select = event.target
    const delay = 100

    this.scheduleSubmit(select, delay)
  }

  // --- Focus management ---
  saveFocus = () => {
    this.focusedElement = document.activeElement
    if (this.focusedElement?.tagName === "INPUT" || this.focusedElement?.tagName === "TEXTAREA") {
      this.selectionStart = this.focusedElement.selectionStart
      this.selectionEnd = this.focusedElement.selectionEnd
    }
  }

  restoreFocus = () => {
    if (!this.focusedElement) return

    const id = this.focusedElement.id
    if (id) {
      const newElement = document.getElementById(id)
      if (newElement) {
        newElement.focus()
        if (this.selectionStart != null) {
          newElement.setSelectionRange(this.selectionStart, this.selectionEnd)
        }
      }
    }

    this.saving = false
    this.spinnerController?.hide()
  }
}
